import {HttpParams} from '@angular/common/http';

export class BluechatSearchCriteria {
  loadNumbers: string[] = [];
  deliveryNumbers: string[] = [];

  public toQueryParams(): HttpParams {

    let params = new HttpParams();

    if (this.loadNumbers.length > 0 && !(this.deliveryNumbers.length > 0)) {
      this.loadNumbers.slice(0, 50).forEach(loadNumber => params = params.append('loadNumbers', loadNumber));
    } else if (this.deliveryNumbers.length > 0 && !(this.loadNumbers.length > 0)) {
      this.deliveryNumbers.slice(0, 50).forEach(deliveryNumber => params = params.append('deliveryNumbers', deliveryNumber));
    }

    return params;
  }
}
